import { isTypeSmallLinkCta, TypeSmallLinkCtaSkeleton } from '@platform/contentful';
import { Entry } from 'contentful';

const ContentfulSmallLinkCta = ({
  entry,
}: {
  entry: Entry<TypeSmallLinkCtaSkeleton, 'WITHOUT_UNRESOLVABLE_LINKS', 'en-US'> | undefined;
}) => {
  if (!entry || !isTypeSmallLinkCta(entry)) {
    return null;
  }

  return (
    <div className='blue-links'>
      {entry.fields.url && <a href={entry.fields.url}>{entry.fields.text}</a>}
    </div>
  );
};

export default ContentfulSmallLinkCta;
